import { render } from "./Wallet.vue?vue&type=template&id=2d8025c9&scoped=true"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"

import "./Wallet.vue?vue&type=style&index=0&id=2d8025c9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d8025c9"

export default script